import { Flex, Heading } from "@chakra-ui/react";

export interface PlantListItemProps {
    content: string;
    footerContent: string;
    image: string;
};

const PlantListItem = (props: PlantListItemProps) => {
    return (
        <Flex 
            flexWrap='wrap' 
            flex='1'
            p='2'
            bg='gray.100'
            justifyContent='center'
        >
            <Flex 
                backgroundImage={ props.image }
                width='300px'
                height='200px'
                backgroundPosition='center'
                backgroundSize='cover'
                marginRight='10px'
                flexWrap='wrap'
            />
            <Flex 
                flex='1' 
                bg='brand.grey'
                p='5'
                flexDirection='column'
            >
                <Flex flex='1'>
                    { props.content }
                </Flex>
                <Flex paddingTop='10px'>
                    <Heading as='h6' size='xs'>
                        { props.footerContent }
                    </Heading>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default PlantListItem;